import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const WinSliderOprion = ({ value, onChange, id='WinSliderOprion', label = 'Slider Option', disabled = false }) => {
    const [selectedWinSliderOprion, setSelectedWinSliderOprion] = useState(value || "Lift Out");
    const [doorData, setDoorData] = useState(null);

    const handleWinSliderOprionChange = (e) => {
        setSelectedWinSliderOprion(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor={id}>{label}</label>
            <select
                disabled={disabled}
                id={id}
                value={selectedWinSliderOprion}
                onChange={handleWinSliderOprionChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Lift Out">{selectedWinSliderOprion === "Lift Out" ? "Lift Out ✔" : "Lift Out"}</option>
                <option value="Tilt">{selectedWinSliderOprion === "Tilt" ? "Tilt ✔" : "Tilt"}</option>
            </select>
        </div>
    );
};

export default WinSliderOprion;
